import Carousel from './Carousel';

const mountCarousel = (element) => {
	const carousel = new Carousel(element);

	if (!carousel.slider) {
		return;
	}

	const configElement = element.closest('[data-autoplay-interval]');
	const interval = configElement ? parseInt(configElement.dataset.autoplayInterval, 10) : 0;
	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (interval > 0 && !reducedMotion) {
		carousel.slider.options = {
			autoplay: true,
			interval: interval,
			pauseOnFocus: true,
			pauseOnHover: true,
			type: 'loop'
		};

		carousel.slider.on('mounted', () => {
			const autoplay = carousel.slider.Components.Autoplay;

			const observer = new IntersectionObserver(([entry]) => {
				if (entry.isIntersecting) {
					autoplay.play();
				} else {
					autoplay.pause();
				}
			}, {threshold: 0});

			observer.observe(element);
		});
	}

	carousel.slider.mount();
};

export default function initCarousels () {
	const carouselElements = document.getElementsByClassName('js-carousel');

	for (const element of carouselElements) {
		if (element.classList.contains('lazyloaded') || !element.classList.contains('lazyload')) {
			mountCarousel(element);
		}
	}

	document.addEventListener('lazybeforeunveil', (e) => {
		if (e.target.classList.contains('js-carousel')) {
			mountCarousel(e.target);
		}
	});
}
